import { NAV_ITEMS, badgeView, type BadgeKey, type NavBadgesResponse } from '@aithora/shared';
import type { Tile } from './operatorBlocks';

/**
 * Needs-action tiles for a building (Facility Admin) or a shift (Care Staff), from the
 * same /nav/badges answer the side nav draws, so the page and the menu never disagree.
 * The server scopes it to the role; a null badge (source could not answer) adds no tile.
 */
export function tilesFromBadges(data: NavBadgesResponse | null): Tile[] {
  if (!data) return [];
  const out: Tile[] = [];
  for (const item of NAV_ITEMS) {
    const key = item.badge;
    if (!key) continue;
    const raw = data.badges[key as BadgeKey];
    if (raw === undefined || raw === null) continue;
    const v = badgeView(key, raw);
    const n = raw.n ?? 0;
    out.push({
      key,
      short: item.label,
      long: raw.aria,
      n,
      text: v && !/^\d+$/.test(v.text) ? v.text : undefined,
      sev: !v ? 'normal' : v.tone === 'red' ? 'breach' : v.tone === 'amber' ? 'risk' : 'normal',
      to: item.path,
      modeled: raw.modeled === true,
    });
  }
  return out;
}
